import React from 'react';
import style from './text.input.less';
import FormComponent from '../FormComponent.jsx';
import DontKnowBtn from '../dont.know.btn/dont.know.btn.jsx';
import { compareObjectsInclusive, isNumberKeyCode, KEY_CODES } from '../../../common/utils.jsx';
import { EMPTY_STRING } from '../../questionnaire.utils.jsx';
import classNames from 'classnames';


const { ENTER, BACKSPACE, DELETE, TAB } = KEY_CODES;
const UNKNOWN = 'UNKNOWN';
export default class TextInput extends FormComponent {
  constructor(props) {
    super();
    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    const { value } = props || { value: EMPTY_STRING };
    this.state = { value };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propsList = [ 'value', 'disabled', 'id', 'name', 'placeholder', 'length', 'unknownAccepted' ];
    const stateIsChanged = this.state.value !== nextState.value;
    return compareObjectsInclusive(this.props, nextProps, propsList) || stateIsChanged;
  }

  onBlur() {
    const value = this.state.value;
    if (value !== EMPTY_STRING) { this.onChangeHandler(value); }
  }
  onChange(event) {
    const value = event.target.value;
    this.setState({ value });
  }
  onKeyDown(event) {
    const onlyNumber = this.props.onlyNumbers;
    const keyCode = event.keyCode;
    if (TAB === keyCode) { return; }
    const isValidKey = BACKSPACE === keyCode || DELETE === keyCode || ENTER === keyCode || isNumberKeyCode(keyCode);
    if (!isValidKey && onlyNumber) { event.preventDefault(); }
  }

  render() {
    const { id, name, placeholder, cssClass, length, unknownAccepted, cssWrapperClass, disabled } = this.props;
    const stateValue = this.state.value;
    const value = (UNKNOWN === stateValue) || (null === stateValue) || ('undefined' === typeof stateValue) ? EMPTY_STRING : stateValue;
    const cssClassName = classNames(style.textInput, cssClass, { [style.disabled]: disabled });
    return (
      <div className={cssWrapperClass}>
        <input
          id={id}
          name={name}
          value={value}
          placeholder={placeholder}
          maxLength={length || null}
          onChange={this.onChange}
          onBlur={this.onBlur}
          onKeyDown={this.onKeyDown}
          className={cssClassName}
          disabled={disabled}
          type="text"
        />
        {unknownAccepted ? (
          <DontKnowBtn
            disabled={disabled}
            onChangeCallback={this.onChangeHandler}
            value={UNKNOWN}
            checked={UNKNOWN === value}
          />
        ) : null}
      </div>
    );
  }
}


